module.exports = __webpack_public_path__ + "img/Avatar-2.8498a98c.gif";